var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "制作签章",
            visible: _vm.viseble,
            width: "550px",
            top: "5vh"
          },
          on: {
            "update:visible": function($event) {
              _vm.viseble = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "madeForm",
              staticClass: "made-style",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": _vm.formLabelWidth
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "签章名称", prop: "signName" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入签章名称",
                      maxlength: "15",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.form.signName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "signName", $$v)
                      },
                      expression: "form.signName"
                    }
                  })
                ],
                1
              ),
              false
                ? _c(
                    "el-form-item",
                    { attrs: { label: "签章样式", prop: "signType" } },
                    [
                      _c("div", { staticClass: "sign-style" }, [
                        _c(
                          "div",
                          {
                            key: "img-1",
                            class: _vm.form.signType == 0 ? "use-style" : "",
                            on: {
                              click: function($event) {
                                return _vm.changeUse(0)
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../static/images/tpl/roundSign.gif"),
                                alt: ""
                              }
                            })
                          ]
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "印章颜色" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "color-radio",
                      on: { change: _vm.medeSign },
                      model: {
                        value: _vm.form.color,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "color", $$v)
                        },
                        expression: "form.color"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _c(
                          "div",
                          {
                            staticClass: "color-item-sty",
                            class: { "select-sty": !!(_vm.form.color == 1) }
                          },
                          [_c("div", { staticClass: "seal-dome red" })]
                        )
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _c(
                          "div",
                          {
                            staticClass: "color-item-sty",
                            class: { "select-sty": !!(_vm.form.color == 2) }
                          },
                          [_c("div", { staticClass: "seal-dome blue" })]
                        )
                      ]),
                      _c("el-radio", { attrs: { label: 3 } }, [
                        _c(
                          "div",
                          {
                            staticClass: "color-item-sty",
                            class: { "select-sty": !!(_vm.form.color == 3) }
                          },
                          [_c("div", { staticClass: "seal-dome black" })]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "环排字（企业名称）", prop: "mainText" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: "25",
                      "show-word-limit": "",
                      placeholder: "请输入企业名称"
                    },
                    model: {
                      value: _vm.form.mainText,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "mainText", $$v)
                      },
                      expression: "form.mainText"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "横排字（抬头文字）" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入抬头文字",
                      maxlength: "5",
                      "show-word-limit": "",
                      disabled: _vm.form.mainText.length > 15
                    },
                    model: {
                      value: _vm.form.titleText,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "titleText", $$v)
                      },
                      expression: "form.titleText"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "印章编码（防伪码）" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入印章编码",
                      maxlength: "15",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.form.signCode,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "signCode", $$v)
                      },
                      expression: "form.signCode"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "预览效果" } },
                [
                  _vm.previewUrl
                    ? _c("div", [
                        _c("img", {
                          attrs: {
                            width: "160px",
                            src: _vm.fileOperShow(_vm.previewUrl),
                            alt: ""
                          }
                        })
                      ])
                    : _vm._e(),
                  _c("el-button", { on: { click: _vm.medeSign } }, [
                    _vm._v("预览效果")
                  ])
                ],
                1
              ),
              _c("p", { staticClass: "tip-text" }, [
                _vm._v(
                  "\n        在线创建印章如不满足需求（企业名称过长），建议使用本地上传方式创建印章。\n      "
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.viseble = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.loading
                  },
                  on: { click: _vm.confirmSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e2066ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e2066ec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/tpl-editor/signOnline.vue
// module id = x3FC
// module chunks = 7 30 134